import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "customValidationError", "dataKey", "help", "labelOverride", "maxInlineSize"];
import { Data } from 'signup-constants/signupData/Data';
import { Step } from 'signup-constants/Step';
import { useInputValidation } from '../signup-data/useInputValidation';
import { useSignupData } from '../signup-data/useSignupData';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useInputProps } from '../signup-data/useInputProps';
import { Text } from 'foundations-components/components/Text';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getShouldShowSidePanel } from '../utils/getShouldShowSidePanel';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormControlLabel = ({
  label
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    typography: 'heading-50',
    children: label
  });
};
const SignupFormControl = _ref => {
  let {
      children,
      customValidationError,
      dataKey,
      help,
      labelOverride,
      maxInlineSize
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isInvalid
  } = useSignupData(dataKey);
  const inputProps = useInputProps(dataKey);
  const {
    getValidationText
  } = useInputValidation({
    dataKey,
    customValidationError
  });
  const shouldShowSidePanel = getShouldShowSidePanel();
  const {
    currentStep
  } = useCurrentStep();
  const label = FormControlLabel({
    label: labelOverride !== null && labelOverride !== void 0 ? labelOverride : inputProps.label
  });
  const formControlMarginBlockStart = () => {
    if (shouldShowSidePanel && dataKey === Data.LastName) {
      return '300';
    }
    if (currentStep === Step.Review) {
      return '0';
    }
    return undefined;
  };
  return /*#__PURE__*/_jsx(FormControl, Object.assign({
    "data-data-key": dataKey,
    error: isInvalid,
    help: help,
    label: label,
    maxInlineSize: maxInlineSize,
    required: true,
    validationMessage: getValidationText()
  }, props, {
    marginBlockStart: formControlMarginBlockStart(),
    children: children
  }));
};
export default SignupFormControl;